



export const IMAGEURL = 'https://bt-dev-storage.s3.ap-south-1.amazonaws.com';


// export const BASE_URL = process.env.REACT_APP_BASE_URL;